import styled from 'styled-components';
import { GREEN_COLOR } from '../constants';

export const ColorBlockSection = styled.section`
  width: 100vw;
  background: ${GREEN_COLOR};
  padding: 9rem 0 6rem;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 7rem 0 4rem;
  }
`;

export const ColorBlockContent = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

export const FloatingTag = styled.div`
  position: absolute;
  background: #d1ff94;
  color: #000000;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.6rem 1.25rem;
  border-radius: 50px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  z-index: 1;
  white-space: nowrap;

  @media (max-width: 768px) {
    display: none;
  }
`;
